/* Workspace Settings' fixed choices: notification categories, roles,
   autonomy levels, API scopes, payment processors, and the guardrail defaults
   a new workspace starts from. */

import type { ApiScope, AutonomyLevel, Guardrails, PermissionCategory, Role } from "@/shared/types";

export const ROLES: Role[] = [
  { id: "owner", label: "Owner" },
  { id: "admin", label: "Admin" },
  { id: "member", label: "Member" },
];

export const API_SCOPES: ApiScope[] = [
  { id: "agents:read", label: "Read agents" },
  { id: "agents:run", label: "Run agents" },
  { id: "tasks:write", label: "Manage tasks" },
  { id: "knowledge:read", label: "Read knowledge" },
  { id: "billing:read", label: "Read billing" },
];

export const AUTONOMY_LEVELS: AutonomyLevel[] = [
  { id: "always", label: "Always ask" },
  { id: "limits", label: "Ask above limits" },
  { id: "auto", label: "Autonomous" },
];

export const PERMISSION_CATEGORIES: PermissionCategory[] = [
  {
    id: "email",
    label: "Send email",
    desc: "Outbound mail from connected Gmail / Outlook accounts.",
    level: "always",
  },
  {
    id: "messages",
    label: "Send messages (Slack)",
    desc: "Posting to channels or DMs on your behalf.",
    level: "limits",
  },
  {
    id: "files",
    label: "Create or modify files",
    desc: "Docs, sheets and repo files in connected apps.",
    level: "auto",
  },
  {
    id: "purchases",
    label: "Make purchases",
    desc: "Any spend on a saved payment method.",
    level: "always",
  },
  {
    id: "code",
    label: "Execute code in sandbox",
    desc: "Isolated sandbox runs — no access to your machine.",
    level: "auto",
  },
  {
    id: "browsers",
    label: "Access private browsers",
    desc: "Logged-in browser sessions with your credentials.",
    level: "limits",
  },
];

export const DEFAULT_GUARDRAILS: Guardrails = {
  monthlyCreditCap: 8000, // out of plan credits
  perRunTokenCap: 120000, // tokens per agent run
  defaultModel: "definable-pro",
};
